import { Typography } from "@mui/material";

export default function SubTitleCard({ children, ...props }) {
  return (
    <Typography variant="h6" color="blue.subTitle" component="h6" sx={{fontSize: '0.8rem'}} {...props}>
      {children}
    </Typography>
  );
}
